import { Link } from 'react-router-dom';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_unit-economics-3/artifacts/z3ko7m68_Cake_Studio.png";

export function Logo({ size = "default", className = "" }) {
  const h = size === "sm" ? "h-10" : size === "lg" ? "h-20" : "h-14";
  return (
    <Link to="/" className={`flex items-center gap-0 ${className}`}>
      <img src={LOGO_URL} alt="ROCH Consultation" className={`${h} w-auto object-contain`} />
    </Link>
  );
}

export function LogoImg({ size = "default", className = "" }) {
  const h = size === "sm" ? "h-10" : size === "lg" ? "h-20" : "h-14";
  return <img src={LOGO_URL} alt="ROCH Consultation" className={`${h} w-auto object-contain ${className}`} />;
}

export const LOGO_SRC = LOGO_URL;
